// Power BI dashboard links
export const DCAM =
  "https://app.powerbi.com/reportEmbed?reportId=847bcff5-d8e7-4d6a-8c1f-b189f6a812ee&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26";

export const WALKDOWN_APP =
  "https://app.powerbi.com/reportEmbed?reportId=1509d2cd-544a-4671-b7db-532c3f0b2e0b&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26";

export const JDE_DATA_PROFILE =
  "https://app.powerbi.com/reportEmbed?reportId=9581a4ff-7cb6-4947-a6ca-aaad0f11e9db&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26";
